import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_ROLES: createAsyncMutation('GET_ROLES')
}

const roles = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getRoles(store) {
            let url = api.roles
            return doAsyncGet(store, { url, mutationTypes: types.GET_ROLES })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}


export default roles
